'use client';

import React, { useEffect, useMemo } from 'react';
import { init } from '@fullstory/browser';
import { useSettings } from '../../../hooks/useSettings';
import { usePageContext } from '../../../hooks/PageContext/usePageContext';
import { DEBUG } from '../../../../../constants/env';
import { RETAIL_MEDIA_APPS } from '../CpCustomComponent/constants';

const FULLSTORY_ORG_ID = 'VC37A';

const FullStoryComponent: React.FC = () => {
  const settings = useSettings();
  const { state } = usePageContext();

  const isRetailMediaAdsPresent = Object.values(
    settings?.customComponents || {},
  ).some((comp: any) =>
    RETAIL_MEDIA_APPS.some((appName) => appName === comp?.name),
  );

  const isMobile = state.deviceType === 'mobile';

  // only capture 0.1% of these sessions for now
  const isSampled = useMemo(() => Math.random() < 0.001, []);

  useEffect(() => {
    if (
      isRetailMediaAdsPresent &&
      isMobile &&
      isSampled &&
      typeof window !== 'undefined'
    ) {
      init({ orgId: FULLSTORY_ORG_ID, devMode: DEBUG, debug: DEBUG });
    }
  }, [isRetailMediaAdsPresent, isMobile, isSampled]);

  return null;
};

export default FullStoryComponent;
